import { render } from "./message-input-choices.vue?vue&type=template&id=00b5e03c&ts=true"
import script from "./message-input-choices.vue?vue&type=script&lang=ts"
export * from "./message-input-choices.vue?vue&type=script&lang=ts"

import "./message-input-choices.vue?vue&type=style&index=0&id=00b5e03c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__